import { lazy, Suspense } from "react";
import { useCards } from "./hooks/useCards";

const CardsView = lazy(() => import("./view"));

export default function CardsPage() {
  const {
    goBack,
    goToNewCard,
    cards,
    selectedCard,
    toggleCardSelection,
    isShowingMenu,
    toggleMenu,
    isVisibleActionCardModal,
    toggleActionCardModal,
    isVisibleConfirmationModal,
    toggleConfirmationModal,
    isVisibleValidationModal,
    toggleValidationModal,
    isVisiblePaymentConfirmationModal,
    togglePaymentConfirmationModal,
    handleToggleAutoPayment,
    handleDeleteCard,
    handleChangePaymentMethodCard,
    isLoading,
    error,
    setError,
  } = useCards();

  return (
    <Suspense fallback={<div className="h-full bg-gray-100" />}>
      <CardsView
        goBack={goBack}
        goToNewCard={goToNewCard}
        cards={cards}
        selectedCard={selectedCard}
        toggleCardSelection={toggleCardSelection}
        isShowingMenu={isShowingMenu}
        toggleMenu={toggleMenu}
        isVisibleActionCardModal={isVisibleActionCardModal}
        toggleActionCardModal={toggleActionCardModal}
        isVisibleConfirmationModal={isVisibleConfirmationModal}
        toggleConfirmationModal={toggleConfirmationModal}
        isVisibleValidationModal={isVisibleValidationModal}
        toggleValidationModal={toggleValidationModal}
        isVisiblePaymentConfirmationModal={isVisiblePaymentConfirmationModal}
        togglePaymentConfirmationModal={togglePaymentConfirmationModal}
        handleToggleAutoPayment={handleToggleAutoPayment}
        handleDeleteCard={handleDeleteCard}
        handleChangePaymentMethodCard={handleChangePaymentMethodCard}
        isLoading={isLoading}
        error={error}
        setError={setError}
      />
    </Suspense>
  );
}
